import { gql } from '@apollo/client';
import { EntityType, IdProofing } from 'routes/marketplace-ede/types/ede/idVerify';

export const idProofingQuery = `entityId
  entityType
  methodType
  methodSubType
  isVerified
  sessionId
  externalReferenceCode
  externalVerificationCode
  internalReferenceCode
  documentType
  documentId
  documents{
    documentType
    documentNumber
    documentId
  }
  documentNumber
  cmsProofingId
  idProofingAttributes {
    firstName
    lastName
    dob
  }
  lastModified`;

const getIdProofingQuery = `
  getIdProofing(
    entityId: $entityId,
    entityType: $entityType,
  ){
    ${idProofingQuery}
  }
`;

const getAllIdProofingQuery = `
  getAllIdProofing(
    entityId: $entityId,
    entityType: $entityType,
  ){
    ${idProofingQuery}
  }
`;

export type GetIdProofingQuery = {
  getIdProofing: IdProofing;
};

export type GetIdProofingQueryArgs = {
  entityId: string;
  entityType: EntityType;
};

const GET_ID_PROOFING = gql`
  query GetIdProofing($entityId: ID!, $entityType: EntityType!) {
    ${getIdProofingQuery}
  }
`;

export type GetAllIdProofingQuery = {
  getAllIdProofing: IdProofing[];
};

export type GetAllIdProofingQueryArgs = {
  entityId: string;
  entityType: EntityType;
};

export const GET_ALL_ID_PROOFING = gql`
  query GetAllIdProofing($entityId: ID!, $entityType: EntityType!) {
    ${getAllIdProofingQuery}
  }
`;

export default GET_ID_PROOFING;
